<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.documentType.question') }}
    </h2>
    <div class="w-full radio-group">
      <zt-radio-button
        :value="'true'"
        v-model="selected"
        name="visible"
        @change="update"
        data-vs-radio-button="documentType"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.documentType.option.label') }}</span>
      </zt-radio-button>
    </div>
    <div class="w-full">
      <zt-radio-button
        :value="'false'"
        v-model="selected"
        name="visible"
        @change="update"
        data-vs-radio-button="documentType"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.documentType.option1.label') }}</span>
      </zt-radio-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubFolderDocumentType',
  inject: ['stateFolder', 'setSubFolderParams'],
  data() {
    return {
      selected: 'false'
    }
  },
  created() {
    this.selected = this.stateFolder.subFolderParams.isDigitalDocument.toString()
  },
  methods: {
    update() {
      const isDigitalDocument = (/^(true|1)$/i).test(this.selected) && !!this.selected
      const type = isDigitalDocument ? 'eform' : 'pdf'
      if (isDigitalDocument) {
        this.setSubFolderParams({
          isDigitalDocument: isDigitalDocument,
          isSalaryReceipt: false,
          isAiDocument: false,
          documentType: type,
          visible: false,
          templateId: ''
        })
      } else {
        this.setSubFolderParams({
          isDigitalDocument: isDigitalDocument,
          documentType: type
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
::v-deep {
  .zt-input-radiobutton {
    label {
      padding-top: 3px;
    }
    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>